var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path2, _circle, _circle2, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.4 343.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e19ab;}.cls-2,.cls-3{fill:none;stroke:#9e19ab;stroke-miterlimit:10;}.cls-2{stroke-width:16px;}.cls-3{stroke-width:11px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.4,196.8l25.4-15V160.3a1.3,1.3,0,0,1,.1-.6c0-1.2.1-7.6-4.3-10.5l-58.3-34.5a9.8,9.8,0,0,0-3.7-1.4,25.8,25.8,0,0,0-10.7.2,9.5,9.5,0,0,0-3.3,1.3l-55.3,31.7s-8.5,4.3-8.5,13v67.3s-.2,5.6,6.1,9.7l58.7,34.2a14.9,14.9,0,0,0,14.8,0l99.8-57.9a10.9,10.9,0,0,1,2.7-1.1c3-.9,9.8-2.3,14.4.5L320,229.3a11.5,11.5,0,0,1,3.3,2.9c1.6,1.9,3.6,5.1,3.5,8.8v36.7c0,.4.1.8.1,1.2s0,5.2-4.8,8.6l-.7.5-32.3,19.5a12.3,12.3,0,0,1-4.9,1.6,23.2,23.2,0,0,1-9.6-1.3,8.5,8.5,0,0,1-2.2-.9l-28.6-16.3a8.3,8.3,0,0,1-1.8-1.3,20.4,20.4,0,0,1-7-14.1,129.5,129.5,0,0,1,.4-21.1l-24,14.4v25.1a11.3,11.3,0,0,0,3.2,8,23.8,23.8,0,0,0,3.6,3.2c6.1,4.4,47.6,28.2,54.7,32.2a8.1,8.1,0,0,0,2.7,1.1c2.7.8,8.3,1.9,13.7,0l2-1,54.8-31.9a18.4,18.4,0,0,0,7.6-9.4,12,12,0,0,0,.5-3.3V224.4a5.4,5.4,0,0,0,0-1.8c-.2-1.3,0-5.1-8.3-9l-1-.5-55.5-32.3s-8.7-5.7-20.2,2.1l-.5.3-94.9,56.9a8.1,8.1,0,0,1-2.1,1,20.8,20.8,0,0,1-12.5.4,12.3,12.3,0,0,1-2.6-1.2l-31.6-19.8a11.1,11.1,0,0,1-4.5-5.1,19.5,19.5,0,0,1-1.7-8.1c0-6,.3-26.6.4-33.8a11.4,11.4,0,0,1,1.8-6.1,19.3,19.3,0,0,1,7.1-6.7l28.2-16.2s9.9-5.3,18.2,0l29.6,17.6a16.3,16.3,0,0,1,7.2,12.3v22.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.6 118.1 169.3 115 153.3 121.5 73.6 118.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.4 139.3 127.9 137.1 127.9 142.3 75.4 139.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.9 161 109.6 158.2 105.8 163.9 54.9 161"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.6 182.2 98.1 180 98.1 184.9 45.6 182.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.8 204.1 95 200 95 207.7 11.8 204.1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.8 225.2 113 222.9 113 227.6 30.8 225.2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.2 247.2 134.7 244.5 134.7 248.8 55.2 247.2"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.1 310.5 236.7 307.8 236.7 312 157.1 310.5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.6 267.5 165.6 265.3 165.6 269.6 53.6 267.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116 288.6 228 286.4 228 290.6 116 288.6"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "121.4 330.8 283.7 326.3 283.7 335 121.4 330.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.3,116.4s-23.7-14.7-19.2-41.7a45.3,45.3,0,0,1,22.8-32.2c11.7-6.5,29.4-9.4,49.9,9.6l11.9-7.3s-24.6-28.9-62.1-12.1c0,0-24.3,10.5-26.6,39.2C255,71.9,252.2,103,278.3,116.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 303.1,
    cy: 78.8,
    r: 66.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 303.1,
    cy: 78.8,
    r: 7.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "309 71.3 348.6 48.2 310.6 75.9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.35573fb076b513f8be49ac5949fa3b7e.svg";
export { ForwardRef as ReactComponent };